<div #tooltipObj="matTooltip" [matTooltip]="tooltip" matTooltipPosition="left" (click)="tooltipObj.toggle()"></div>
<fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
